import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { storePassword } from "../../config/action";
import RequiredLabel from "./RequiredLabel/RequiredLabel";

interface Props {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  strongValidate?: boolean;
  errorFlag?: boolean;
  className?: string;
}

const PasswordInput: React.FC<Props> = ({
  label,
  name,
  value,
  onChange,
  required = false,
  strongValidate = false,
  errorFlag = false,
  className,
}) => {
  const [show, setShow] = useState(false);
  let dispatch = useDispatch();

  const isEmpty = required && errorFlag && value === "";

  const isInvalid =
    strongValidate && value?.length > 0 && !validatePassword(value);

  let errorMessage = "";

  if (isEmpty) errorMessage = `Please enter ${label.toLowerCase()}`;
  else if (isInvalid)
    errorMessage =
      "Password must be at least 8 characters and include uppercase, lowercase, number and special character.";

  return (
    <div className="text-start position-relative mb-2">
      <RequiredLabel isRequired={true}>{label}</RequiredLabel>

      <div className="position-relative">
        <Form.Control
          type={show ? "text" : "password"}
          name={name}
          value={value}
          className={className}
          style={{ paddingRight: "40px" }}
          placeholder="Enter your password"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const pwd = e.target.value;

            if (pwd) {
              sessionStorage.setItem("temp_password", pwd);
            }

            onChange(e);
          }}
          autoComplete="new-password"
        />

        <span
          className="position-absolute end-0 top-50 translate-middle-y pe-3 text-secondary cursor-pointer"
          style={{ zIndex: 5, background: "transparent", border: "none" }}
          onClick={() => setShow(!show)}
        >
          {show ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
        </span>
      </div>

      {errorMessage && <small className="text-danger">{errorMessage}</small>}
    </div>
  );
};

export default PasswordInput;

// 🔐 validation
export const validatePassword = (password: string) => {
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).{8,}$/;

  return regex.test(password);
};
